/* PILSNERISH OS — cart API + CART.EXE drawer
 * PZ.cart.add(variantId, qty, props) -> Promise<cart item | throws>
 * PZ.cart.open(), PZ.cart.close(), PZ.cart.refresh(), PZ.cart.change(line, qty)
 * Dispatches `pz:cart-updated` on document with detail { count }.
 */
(function () {
  'use strict';
  var w = window, d = document;
  var PZ = (w.PZ = w.PZ || {});
  var routes = w.routes || {};
  var root = (routes.root || '/').replace(/\/?$/, '/');
  var DRAWER_SECTION = 'pz-cart-drawer';
  var lastFocus = null;

  function drawer() { return d.querySelector('[data-pz-drawer]'); }
  function sectionIds() {
    var ids = [DRAWER_SECTION];
    d.querySelectorAll('[data-pz-cart-root][data-section]').forEach(function (el) {
      var id = el.getAttribute('data-section');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }
  function render(sections) {
    if (!sections) return;
    var count = null;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-pz-cart-root]');
      if (!fresh) return;
      var c = fresh.getAttribute('data-count');
      if (c != null) count = parseInt(c, 10);
      d.querySelectorAll('[data-pz-cart-root][data-section="' + id + '"]').forEach(function (target) {
        target.innerHTML = fresh.innerHTML;
        target.setAttribute('data-count', c || '0');
      });
    });
    if (count != null) setCount(count);
  }
  function setCount(n) {
    d.querySelectorAll('[data-pz-cart-count]').forEach(function (el) {
      el.textContent = PZ.pad ? PZ.pad(n) : String(n);
    });
    d.dispatchEvent(new CustomEvent('pz:cart-updated', { detail: { count: n } }));
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok || json.status) {
          var msg = json.description || json.message || 'cart error';
          /* R4: never reveal stock counts. Shopify's 422 texts ("All 3 X are in your cart", "You can only add 2 X")
             carry the quantity, so any stock error with a number in it becomes a count-free line. */
          if (r.status === 422 && /\d/.test(msg)) msg = "can't add that many right now.";
          var err = new Error(msg);
          err.status = r.status; err.json = json;
          throw err;
        }
        return json;
      });
    });
  }

  var cart = {
    add: function (variantId, qty, props) {
      var item = { id: Number(variantId), quantity: Math.max(1, parseInt(qty, 10) || 1) };
      if (props && Object.keys(props).length) item.properties = props;
      return post((routes.cart_add_url || root + 'cart/add') + '.js', {
        items: [item],
        sections: sectionIds().join(','),
        sections_url: w.location.pathname
      }).then(function (json) {
        render(json.sections);
        return json;
      });
    },
    change: function (line, qty) {
      return post((routes.cart_change_url || root + 'cart/change') + '.js', {
        line: Number(line), quantity: Math.max(0, parseInt(qty, 10) || 0),
        sections: sectionIds().join(','),
        sections_url: w.location.pathname
      }).then(function (json) {
        render(json.sections);
        return json;
      });
    },
    refresh: function () {
      var url = root + '?sections=' + encodeURIComponent(sectionIds().join(','));
      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (json) { render(json); return json; });
    },
    open: function () {
      var dr = drawer();
      if (!dr) { w.location.href = routes.cart_url || root + 'cart'; return; }
      if (dr.classList.contains('is-open')) return;
      lastFocus = d.activeElement;
      dr.hidden = false;
      dr.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () { requestAnimationFrame(function () { dr.classList.add('is-open'); }); });
      if (PZ.lock) PZ.lock(true);
      var focusable = dr.querySelector('[data-pz-drawer-close]:not(.pz-drawer__scrim), button, a');
      setTimeout(function () { if (focusable) focusable.focus({ preventScroll: true }); }, 60);
      d.dispatchEvent(new CustomEvent('pz:cart-open'));
    },
    close: function () {
      var dr = drawer();
      if (!dr || !dr.classList.contains('is-open')) return;
      dr.classList.remove('is-open');
      dr.setAttribute('aria-hidden', 'true');
      if (PZ.lock) PZ.lock(false);
      var done = function () { if (!dr.classList.contains('is-open')) dr.hidden = true; };
      if (PZ.reduced) done(); else setTimeout(done, 420);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
  };
  PZ.cart = cart;

  /* ---------- delegated UI ---------- */
  d.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest('[data-pz-cart-open]');
    if (opener && drawer()) { e.preventDefault(); cart.open(); return; }
    if (t.closest('[data-pz-drawer-close]')) { e.preventDefault(); cart.close(); return; }
    var qbtn = t.closest('[data-pz-line-qty]');
    if (qbtn) {
      e.preventDefault();
      var row = qbtn.closest('[data-line]');
      if (!row) return;
      var line = row.getAttribute('data-line');
      var current = parseInt(row.getAttribute('data-qty'), 10) || 0;
      var delta = qbtn.getAttribute('data-pz-line-qty');
      var next = delta === 'remove' ? 0 : current + parseInt(delta, 10);
      row.classList.add('is-busy');
      cart.change(line, next).catch(function (err) {
        row.classList.remove('is-busy');
        var msg = row.querySelector('[data-line-error]');
        if (msg) { msg.hidden = false; msg.textContent = '[ERR] ' + (err.message || 'could not update'); }
      });
    }
  });
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cart.close();
    if (e.key === 'Tab') {
      var dr = drawer();
      if (!dr || !dr.classList.contains('is-open')) return;
      var f = Array.prototype.slice.call(dr.querySelectorAll('a[href], button:not([disabled]), input, select, textarea')).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  /* bfcache: cart may have changed on another page */
  w.addEventListener('pageshow', function (e) { if (e.persisted) cart.refresh(); });
})();
